import type { SessionDto } from '@/features/session/data/dto/session.dto.ts'
import type { TracksData } from '@/shared/store/tracks.store.tsx'
import { isDeepEqual } from '@/utils/is-deep-equal'
import { WorkflowId } from '@/models'

export const hasTimelineClips = (timeline?: TracksData): boolean =>
  timeline?.tracks.some(({ clips }) => clips.length > 0) ?? false

export const shouldRebuildTimelineFromAudioform = (
  sessionDto: SessionDto
): boolean => {
  const state = sessionDto.state ?? {}

  return (
    sessionDto.workflowId === (WorkflowId.PRO_EDITOR as string) &&
    !isDeepEqual(state, {}) &&
    !hasTimelineClips(state.timeline) &&
    !!sessionDto.audioformId
  )
}
